module.exports = __webpack_public_path__ + "media/renare-rum.af08de00.mp4";